import React from 'react'
import { clamp } from '@utils/math'
import { useHorizontalTimelineContext } from '../context'
import { stageWidthSelector, stageHeightSelector } from '../selectors/stage_selectors'
import { scrollerSelector } from '../selectors/scroller_selectors'
import {
  timelineBoundsSelector,
  displayableTimelineItemsSelector,
  getDrilledDownTimelineItem,
  expandedItemBoundsSelector,
} from '../selectors/timeline_display_selectors'
import { cancelFreeScroll, updateLeftAndRight, drillDownIntoTimelineItem, drillOutOfTimelineItem } from '../actions'
import Timeline from '../components/timeline/Timeline'
import type { Timeline as TimelineType, Photo } from '@app-types/entity_types'
import type { DerivedMarker, DerivedTimespan } from '../types/derived_items'
import type { TimelineItemType } from '../types/types'

type TimelineDisplayContainerProps = {
  timeline: TimelineType | any
  markers: DerivedMarker[]
  timespans: DerivedTimespan[]
  photos: Record<string, Photo>
}

const TimelineDisplayContainer: React.FC<TimelineDisplayContainerProps> = props => {
  const { timeline, markers, timespans, photos } = props
  const { state, dispatch } = useHorizontalTimelineContext()

  const displayableTimelineItems = displayableTimelineItemsSelector(state, props)
  const timelineDisplayBounds = timelineBoundsSelector(state, props)
  const drilledDownTimelineItem = getDrilledDownTimelineItem(state, props)
  const expandedItemBounds = expandedItemBoundsSelector(state, props)
  const stageWidth = stageWidthSelector(state, props)
  const stageHeight = stageHeightSelector(state, props)
  const scrollerData = scrollerSelector(state, props)

  const newProps = {
    ...props,

    timeline,
    markers,
    timespans,
    photos,
    displayableTimelineItems,
    timelineDisplayBounds,
    drilledDownTimelineItem,
    expandedItemBounds,
    stageWidth,
    stageHeight,
    scrollerData,

    onPanStart: () => {
      dispatch(cancelFreeScroll())
    },
    onPanMove: (left: number, right: number) => {
      dispatch(updateLeftAndRight(clamp(left, 0, 1), clamp(right, 0, 1)))
    },
    onPanEnd: () => {},
    onTimelineItemDrillDown: (id: number | string, timelineItemType: TimelineItemType) => {
      dispatch(drillDownIntoTimelineItem(id, timelineItemType))
    },
    onTimelineItemDrillUp: (id: number | string, timelineItemType: TimelineItemType) => {
      dispatch(drillOutOfTimelineItem(id, timelineItemType))
    },
  }
  return <Timeline {...newProps} />
}

export default TimelineDisplayContainer
